<template>
  <div class="container-row">
    <div>
      <div class="custom-control custom-checkbox">
        <input
          :id="'section_' + section.id"
          v-model="section.selected"
          :name="'section_' + section.id"
          type="checkbox"
          class="custom-control-input"
          :disabled="section.readOnly"
          @change="setSelectionValues(section)"
        />
        <label :for="'section_' + section.id" class="custom-control-label font">
          {{ section.text }}
        </label>
      </div>
    </div>
    <div v-if="section.selected">
      <div class="subcontainer container w-100">
        <div class="row pt-1 pb-1">
          <div
            v-for="option in section.suboptions"
            :key="'subOptions_' + option.id"
            class="custom-control custom-checkbox col-4"
          >
            <input
              :id="'subOptions_' + option.id"
              v-model="selectedOptions"
              type="checkbox"
              :name="'subOptions_' + option.id"
              class="custom-control-input"
              :disabled="option.readOnly"
              :value="option.id"
              @change="
                $emit('subOptionSelected', {
                  id: section.id,
                  optionThatGenerateEvent: option.id,
                  options: selectedOptions
                })
              "
            />
            <label
              class="custom-control-label"
              :for="'subOptions_' + option.id"
            >
              {{ option.text }}
            </label>
          </div>
        </div>
      </div>
      <div
        v-if="
          selectedOptions.includes(servicesOption) &&
            section.id == sectionVIII &&
            isAmendmentCorrelationLogicActive
        "
        class="mb-4"
      >
        <br />
        <strong class="pt-5 pt-4 font">
          Servicios
        </strong>
        <br />
        <div
          class="d-flex align-items-center pt-1 pb-1 ml-2"
          v-for="(item, i) in studentServices"
          :key="i"
        >
          <div class="custom-control custom-checkbox container-service">
            <input
              :id="item.id"
              type="checkbox"
              :name="item.serviceName"
              v-model="item.selected"
              class="custom-control-input"
              @input="selectSubSection(i)"
            />
            <label class="custom-control-label" :for="item.id">
              {{ item.serviceName }}
            </label>
          </div>
          <div class="ml-5" v-if="item.selected">
            <label class="label mt-2" :for="'subOptions_'">
              ¿El cambio es relacionado a la transportación del servicio
              seleccionado?
            </label>
          </div>
          <div class="ml-5 custom-control custom-checkbox" v-if="item.selected">
            <input
              :id="`si-${item.selectedYes}-${item.id}`"
              type="checkbox"
              name="si"
              class="custom-control-input"
              v-model="item.selectedYes"
              :value="item.selectedYes"
              @input="acceptedSelection(i)"
            />
            <label
              class="custom-control-label"
              :for="`si-${item.selectedYes}-${item.id}`"
            >
              Si
            </label>
          </div>
          <div class="ml-5 custom-control custom-checkbox" v-if="item.selected">
            <input
              :id="`no-${item.selectedNo}-${item.id}`"
              type="checkbox"
              name="no"
              class="custom-control-input"
              v-model="item.selectedNo"
              :value="item.selectedNo"
              @input="negativeSelection(i)"
            />
            <label
              class="custom-control-label"
              :for="`no-${item.selectedNo}-${item.id}`"
            >
              No
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "../../common/CustomInput";
import sectionAmendment from "@/utils/constants/pei/sectionAmendment";
export default {
  name: "Row",
  props: {
    services: {
      type: Array,
      default: []
    },
    section: {
      type: Object,
      default: {}
    },
    isAmendmentCorrelationLogicActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedOptions: [],
      servicesOption: 42,
      studentServices: [],
      selectedSubOptionsYes: null,
      selectedSubOptionsNo: null,
      valor: null
    };
  },
  computed: {
    isChecked() {
      return this.section.selected && this.section.suboptions.length > 0;
    },
    sectionVIII() {
      return sectionAmendment.viii;
    }
  },
  watch: {
    isChecked() {
      this.selectedOptions = [];
    }
  },
  components: [CustomInput],
  mounted() {
    this.studentServices = this.services;
  },
  methods: {
    negativeSelection(e) {
      if (!this.studentServices[e].selectedNo) {
        this.studentServices[e].selectedYes = false;
      }
      this.$emit("getSectionService", this.studentServices);
    },
    acceptedSelection(e) {
      if (!this.studentServices[e].selectedYes) {
        this.studentServices[e].selectedNo = false;
      }
      this.$emit("getSectionService", this.studentServices);
    },
    selectSubSection(e) {
      if (!this.studentServices[e].selected) {
        this.studentServices[e].selectedNo = null;
        this.studentServices[e].selectedYes = null;
      }
      this.$emit("getSectionService", this.studentServices);
    },
    setSelectionValues(val) {
      this.$emit("setLogicBySelection", {
        value: val,
        optionsSelected: this.selectedOptions
      });
    },
    selectElement(element) {
      this.$nextTick(() => {
        this.selectedOptions.push(element);
      });
    }
  }
};
</script>

<style scoped>
.container-row:nth-child(odd) {
  background-color: #fafbfa;
}

.option-input {
  margin-right: 20px;
  margin-left: 20px;
}

.container-row {
  padding: 30px;
  border-bottom: solid 1px #b4b4b4;
}

.subcontainer {
  width: 40%;
  margin-left: 35px;
}

.grid-suboptions {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.custom-control-label.header {
  color: #11291b;
  padding-top: 4px;
  font-weight: bold;
}
.custom-control-label {
  color: #11291b;
  font-weight: normal;
}
.font {
  font-weight: bold;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2db782;
  background-color: #2db782;
}

/************* end of custom radio *****************/
.checkbox label:after,
.radio label:after {
  content: "";
  display: table;
  clear: both;
}

.checkbox .cr,
.radio .cr {
  position: relative;
  display: inline-block;
  border: 2px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.4em;
  height: 1.4em;
}

.cr {
  border-radius: 50%;
}

.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.8em;
  line-height: 0;
  top: 50%;
  left: 13%;
}

.cr-icon {
  margin-top: 0.04em;
}

.checkbox label input[type="checkbox"],
.radio label input[type="radio"] {
  display: none;
}

.checkbox label input[type="checkbox"] + .cr > .cr-icon,
.radio label input[type="radio"] + .cr > .cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked + .cr > .cr-icon,
.radio label input[type="radio"]:checked + .cr > .cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled + .cr,
.radio label input[type="radio"]:disabled + .cr {
  opacity: 0.5;
}
.rounded-top {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/************* end of custom radio *****************/
.container-service {
  width: 180px;
}
</style>
